import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'Home',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'PIM_00020',
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: 'Configurações',
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'PIM_00033',
                    edit                    : 'PIM_00034',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/definitions`,
                },
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'PIM_00039',
                    detail                  : 'PIM_00040',
                    add                     : 'PIM_00041',
                    edit                    : 'PIM_00042',
                    delete                  : 'PIM_00043',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/defaultlayers`,
                    getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate               : `${codeAPI}/gestao/defaultlayers`,
                    getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources            : `${codeAPI}/gestao/defaultlayers/resources`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: 'Camadas',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'PIM_00024',
                    detail                  : 'PIM_00023',
                    add                     : 'PIM_00021',
                    edit                    : 'PIM_00022',
                    delete                  : 'PIM_00025',
                    private                 : 'PIM_00021',
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                },
            },
            printinventories: {
                menu: {
                    route: `${code}.printinventories`,
                    text: 'Impressão Inventário',
                    icon: 'fas fa-tasks',
                },
                acl: {
                    view                    : 'PIM_00031',
                    detail                  : 'PIM_00030',
                    add                     : 'PIM_00026',
                    edit                    : 'PIM_00028',
                    delete                  : 'PIM_00032',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/printinventories`,
                    getShow                 : `/${codeAPI}/gestao/printinventories/:id`,
                    getCreate               : `/${codeAPI}/gestao/printinventories`,
                    getUpdate               : `/${codeAPI}/gestao/printinventories/:id`,
                    getDelete               : `/${codeAPI}/gestao/printinventories/:id`,

                    getConfig               : `/${codeAPI}/gestao/printinventories/settings`,
                    getScales               : `/${codeAPI}/gestao/printinventories/scales`,
                    getApps                 : `/${codeAPI}/gestao/printinventories/print/apps`,
                    getLayouts              : `/${codeAPI}/gestao/printinventories/print/layouts/:appid`,
                    getFormats              : `/${codeAPI}/gestao/printinventories/print/formats/:appid`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: 'print_visible_emissions.titles',
                    icon: 'fas fa-print',
                },
                acl: {
                    view                    : 'PIM_00036',
                    config                  : 'PIM_00036',
                    configEdit              : 'PIM_00037',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/printvisible`,

                    getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                    getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                },
            },
        },
        tools: {

        }
    },
};

export default state;